// @ts-nocheck
import siteMessage from "@insite/client-framework/SiteMessage";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getCurrentShipToState } from "@insite/client-framework/Store/Data/ShipTos/ShipTosSelectors";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import TextField, { TextFieldPresentationProps } from "@insite/mobius/TextField";
import constants from "@store/constants";
import setFieldValue from "@store/Framework/Store/Greif/Components/RecommendedProductRequestForm/Handlers/SetFieldValue";
import { RecommendedProductRequestFormContext } from "@store/Library/Widgets/RecommendedProductRequest/RecommendedProductRequestForm";
import React, { ChangeEvent, FC, useContext, useEffect, useState } from "react";
import { connect, ResolveThunks } from "react-redux";

const enum fields {
    isDisabled = "isDisabled",
    isRequired = "isRequired",
}

interface OwnProps extends WidgetProps {
    fields: {
        [fields.isDisabled]: boolean;
        [fields.isRequired]: boolean;
    };
}

const mapStateToProps = (state: ApplicationState) => ({
    currentShipTo: getCurrentShipToState(state),
    customerCompany: state.greif.components.recommendedProductRequestForm.fieldValues["customerCompany"],
});

const mapDispatchToProps = {
    setFieldValue,
};

type Props = OwnProps & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps>;

export interface CustomerCompanyStyles {
    customerCompanyTextField?: TextFieldPresentationProps;
}

export const customerCompanyStyles: CustomerCompanyStyles = {};

const styles = customerCompanyStyles;

const CustomerCompany: FC<Props> = ({ fields, currentShipTo, customerCompany, setFieldValue }) => {
    const { isRequired, isDisabled } = fields;
    const recommendedProductRequestFormContext = useContext(RecommendedProductRequestFormContext);
    const [customerCompanyErrorMessage, setCustomerCompanyErrorMessage] = useState("");

    const customerCompanyLabel = translate("Customer Company");

    useEffect(() => {
        if (currentShipTo.value && !currentShipTo.isLoading) {
            setFieldValue({ key: "customerCompany", value: currentShipTo.value.customerName });
        }
    }, [currentShipTo]);

    useEffect(() => {
        recommendedProductRequestFormContext.validators.customerCompany = validateCustomerCompany;
        if (typeof customerCompany !== "undefined") {
            validateCustomerCompany();
        }
    }, [customerCompany]);

    useEffect(() => {
        recommendedProductRequestFormContext.validators.customerCompany = validateCustomerCompany;
    }, [isRequired]);

    const validateCustomerCompany = () => {
        const errorMessage =
            isRequired && !customerCompany ? siteMessage("Field_Required", customerCompanyLabel).toString() : "";
        setCustomerCompanyErrorMessage(errorMessage);
        return !errorMessage;
    };

    const customerCompanyChangeHandler = (event: ChangeEvent<HTMLInputElement>) => {
        setFieldValue({ key: "customerCompany", value: event.target.value });
    };

    return (
        <TextField
            {...styles.customerCompanyTextField}
            label={customerCompanyLabel}
            value={customerCompany || ""}
            onChange={customerCompanyChangeHandler}
            required={isRequired}
            error={customerCompanyErrorMessage}
            disabled={isDisabled}
        />
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(CustomerCompany),
    definition: {
        displayName: "Customer Company",
        group: constants.widgetGroup.recommendedProductRequest,
        icon: "input-pipe",
        allowedContexts: [constants.pageType.recommendedProductRequest],
        fieldDefinitions: [
            {
                name: fields.isDisabled,
                displayName: "Disabled?",
                editorTemplate: "CheckboxField",
                defaultValue: true,
                fieldType: "General",
            },
            {
                name: fields.isRequired,
                displayName: "Required Field",
                editorTemplate: "CheckboxField",
                defaultValue: false,
                fieldType: "General",
            },
        ],
    },
};

export default widgetModule;
